import { Box, Text } from '@wix/design-system';
import React from 'react';
import MediaAlternativeRuleThumbnail from './media-alternative-rule-thumbnail';
export const MediaAlternativesRuleHeader = _ref => {
  let {
    title,
    disabled = false,
    sourceType,
    uri
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    cursor: disabled ? 'default' : 'pointer',
    width: "216px"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    backgroundColor: "D75",
    border: "1px solid #E2E3EA",
    borderRadius: "4px",
    height: "30px",
    verticalAlign: "middle",
    width: "30px"
  }, /*#__PURE__*/React.createElement(MediaAlternativeRuleThumbnail, {
    sourceType: sourceType,
    uri: uri
  })), /*#__PURE__*/React.createElement(Box, {
    marginLeft: "SP2",
    verticalAlign: "middle",
    width: "170px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    ellipsis: true
  }, title)));
};
//# sourceMappingURL=media-alternatives-rule-header.js.map